import { useSuspenseQuery } from '@tanstack/react-query';
import { SourcingAnalytics, SourcingService } from 'api-clients/monolith';
import { subDays } from 'date-fns';
import { type DateRange } from 'react-day-picker';

import { queryKeys } from '@/query-keys';

import { MetricIndicator } from './metric-indicator';

const METRIC_ORDER: (keyof SourcingAnalytics)[] = [
  'budget_spent',
  'hired_count',
  'average_cph',
  'applied_count',
  'average_cpa',
];

interface MetricsProps {
  dateRange: DateRange;
}

export function Metrics({ dateRange }: MetricsProps) {
  const {
    data: { analytics: analyticsData },
  } = useSuspenseQuery({
    queryKey: [...queryKeys.dashboard.analytics, dateRange],
    queryFn: () =>
      SourcingService.getInternalApiSourcingDashboardAnalytics(
        (dateRange.from ?? subDays(new Date(), 15)).toISOString(),
        (dateRange.to ?? new Date()).toISOString(),
      ),
  });

  return (
    <div className="flex flex-row justify-between px-6 py-4">
      {METRIC_ORDER.map(key => (
        <MetricIndicator key={key} metricKey={key} value={analyticsData[key]} />
      ))}
    </div>
  );
}

Metrics.Skeleton = function MetricsSkeleton() {
  return (
    <div className="flex flex-row justify-between px-6 py-4">
      {METRIC_ORDER.map(key => (
        <MetricIndicator.Skeleton key={key} metricKey={key} />
      ))}
    </div>
  );
};
